var _linearGradient, _linearGradient2, _linearGradient3, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChromeBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 190 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 28.3,
    x2: 80.8,
    y1: 75,
    y2: 44.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a52714",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 109.9,
    x2: 51.5,
    y1: 164.5,
    y2: 130.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#055524",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 121.9,
    x2: 136.6,
    y1: 49.8,
    y2: 114.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ea6100",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 91.2,
    cy: 55,
    r: 84.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 20.9,
    cy: 47.5,
    r: 78,
    xlinkHref: "#a"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 94.8,
    cy: 95.1,
    r: 87.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 33.3,
    cy: 31,
    r: 176.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    r: 88
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#db4437",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0f9d58",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ffcd40",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#h)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3e2723",
    d: "M61.3 114.7L21 47.4l39 67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M128.8 116.3l-.8-.4-37.3 67 38.3-67z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M7 183h83.8l39-39v-29H60.2L7 23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M95 55l34.6 60L91 183h92V55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M21 7v108h39.4L95 55h88V7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M95 55v21l78.4-21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M21 47.5l57.2 57.2L60.4 115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M90.8 183l21-78.3 17.8 10.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    r: 40,
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    r: 32,
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    r: 88,
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e2723",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.6 115a40 40 0 01-69.2 0L7 24.5 60.4 116a40 40 0 0069.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 55h-.5a40 40 0 110 80h.5c22 0 40-18 40-40s-18-40-40-40zm-1 127a88 88 0 0088-87.5v.5A88 88 0 017 95v-.5A88 88 0 0095 182z"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M130 116.3a39.3 39.3 0 003.4-32 38 38 0 01-3.8 30.7L92 183l38.2-66.5zM95 8a88 88 0 0188 87.5V95A88 88 0 007 95v.5A88 88 0 0195 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 54c-22 0-40 18-40 40v1c0-22 18-40 40-40h88v-1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeBrowser);
export default __webpack_public_path__ + "static/media/chrome-browser.1b3af74a3e25942e39c46e3185314eca.svg";
export { ForwardRef as ReactComponent };